import React, { useState } from "react";

export default function LowStockReports() {
  const [search, setSearch] = useState("");
  const [published, setPublished] = useState("All");

  const products = [
    {
      name: "Reversible Horseferry Check Belt",
      inventoryMethod: "Track inventory",
      stockQty: 0,
      published: false,
    },
  ];

  // ✅ Filter products
  const filteredProducts = products.filter((p) => {
    const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
    const matchesPublished =
      published === "All"
        ? true
        : published === "Published"
        ? p.published
        : !p.published;
    return matchesSearch && matchesPublished;
  });

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <h1 className="text-xl font-semibold text-gray-800">Low Stock</h1>
        <a
          href="#"
          className="text-blue-600 text-sm hover:underline whitespace-nowrap"
        >
          Learn more about reports
        </a>
      </div>

      {/* Filters */}
      <div className="bg-white shadow-sm rounded-lg p-4 mb-6">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-end">
          <div className="flex flex-col w-full sm:w-1/3">
            <label className="text-gray-600 text-sm mb-1">Search</label>
            <input
              type="text"
              placeholder="Search by product name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div className="flex flex-col w-full sm:w-1/3">
            <label className="text-gray-600 text-sm mb-1">Published</label>
            <select
              value={published}
              onChange={(e) => setPublished(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option>All</option>
              <option>Published</option>
              <option>Unpublished</option>
            </select>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white shadow-sm rounded-lg">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">Product name</th>
              <th className="py-3 px-4 font-medium">Inventory method</th>
              <th className="py-3 px-4 font-medium">Stock quantity</th>
              <th className="py-3 px-4 font-medium">Published</th>
              <th className="py-3 px-4 font-medium text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {filteredProducts.length > 0 ? (
              filteredProducts.map((p, i) => (
                <tr key={i} className="border-t hover:bg-gray-50">
                  <td className="py-3 px-4">{p.name}</td>
                  <td className="py-3 px-4">{p.inventoryMethod}</td>
                  <td className="py-3 px-4">{p.stockQty}</td>
                  <td className="py-3 px-4">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        p.published
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {p.published ? "Published" : "Unpublished"}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center">
                    <button className="text-blue-600 hover:underline">
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4 text-gray-500">
                  No products found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Previous
          </button>
          <span>1</span>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Next
          </button>
        </div>
        <div className="flex items-center gap-2">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>
        <p>1–1 of 1 items</p>
      </div>
    </div>
  );
}
